import { FormFields } from 'hooks';

export type WriteReviewFormFieldNames = 'title' | 'comment';

export const formFields: FormFields<WriteReviewFormFieldNames> = {
  title: {
    name: 'title',
    initialValue: '',
    isRequired: true,
    requiredMessage: 'Review title is required',
    validate: value => {
      if (value.trim().length > 100) {
        return { isValid: false, error: 'Title must be 100 characters or fewer' };
      }

      return { isValid: true, error: '' };
    }
  },
  comment: {
    name: 'comment',
    initialValue: '',
    isRequired: true,
    requiredMessage: 'Review is required',
    validate: value => {
      if (value.trim().length < 10) {
        return { isValid: false, error: 'Review must be at least 10 characters' };
      }
      if (value.length > 2000) {
        return { isValid: false, error: 'Review must be 2000 characters or fewer' };
      }

      return { isValid: true, error: '' };
    }
  }
};
